export const GET_BG = '/service/getBg'
export const LOGIN = '/login'
export const LOGOUT = '/logout'
export const GET_NODES = '/service/getTreeNodes'
export const GET_RELAYS = '/service/getRelayList'
export const GET_AREA_LIST = '/area/pub/get?pid=0'

//AREA URL
export const GET_AREA = "/area/pub/get"
export const GET_SELF_AREA = "/area/self/get"
export const GET_PROJ_SELF_AREA = "/project/self/area/get"
export const AREA_ADD = "/area/add"
export const AREA_UPDATE = "/area/modify"
export const AREA_DEL = "/area/delete"

//COMPANY URL
export const GET_COMPANY_LIST = "/platform/enterprise/list/get"
export const COMPANY_ADD = "/platform/enterprise/add"
export const COMPANY_UPDATE = "/platform/enterprise/update"
export const COMPANY_DEL = "/platform/enterprise/del"

//AGENTS URL
export const GET_AGENT_LIST = "/enterprise/agents/list/get"
export const AGENT_ADD = "/enterprise/agents/add"
export const AGENT_UPDATE = "/enterprise/agents/update"
export const AGENT_DEL = "/enterprise/agents/del"

//PROJECT URL
export const COMPANY_GET_PROJECT_LIST = "/enterprise/project/list/get"
export const COMPANY_PROJECT_ADD = "/enterprise/project/add"
export const COMPANY_PROJECT_DEL = "/enterprise/project/del"
export const COMPANY_PROJECT_UPDATE = "/enterprise/project/update"

export const AGENT_GET_PROJECT_LIST = "/agents/project/list/get"
export const AGENT_PROJECT_ADD = "/agents/project/add"
export const AGENT_PROJECT_DEL = "/agents/project/del"
export const AGENT_PROJECT_UPDATE = "/agents/project/update"

//PROJECT　STATISTICS
export const PROJECT_STATISTICS_NEW_USER = "/projanal/users/time/get"
export const PROJECT_STATISTICS_CONSUME = "/projanal/orders/type/get"
export const PROJECT_STATISTICS_FEE = "/projanal/orders/fee/get"
export const PROJECT_STATISTICS_CHARGE_TIME = "/projanal/orders/duration/get"
export const PROJECT_STATISTICS_COMBOS = "/projanal/combos/time/get"

//PROJECT MAP
export const PROJECT_MAP_ORDER_LIST = "/statistic/area/project/order/list/get"
export const PROJECT_MAP_AREA_ORDER_LIST = "/statistic/area/project/order/count/list/get"
export const PROJECT_MAP_AREA_SOCKET_LIST = "/statistic/area/project/socket/count/list/get"


//GROUP USER URL
export const PLATFORM_USER_LIST = "/platform/user/list/get"
export const PLATFORM_USER_ADD = "/platform/user/add"
export const PLATFORM_USER_DEL = "/platform/user/del"
export const PLATFORM_USER_UPDATE = "/user/update"

export const COMPANY_USER_LIST = "/enterprise/user/list/get"
export const COMPANY_USER_ADD = "/enterprise/user/add"
export const COMPANY_USER_DEL = "/enterprise/user/del"
export const COMPANY_USER_UPDATE = "/user/update"

export const AGENTS_USER_LIST = "/agents/user/list/get"
export const AGENTS_USER_ADD = "/agents/user/add"
export const AGENTS_USER_DEL = "/agents/user/del"
export const AGENTS_USER_UPDATE = "/user/update"

export const PROJECT_USER_LIST = "/project/user/list/get"
export const PROJECT_USER_ADD = "/project/user/add"
export const PROJECT_USER_DEL = "/project/user/del"
export const PROJECT_USER_UPDATE = "/user/update"

//ALARM URL
export const ALARM_LIST_GET = "/alarm/list"

//DEV URL
export const GATEWAY_LIST_GET = "/gateway/list/get"
export const TERMINAL_LIST_GET = "/terminal/get"
export const TERMINAL_LIST_BY_SN = "/terminal/list/get"
export const AGENT_CURRENT_GET = "/agents/current/list/get"
export const GATEWAY_EDIT = "/gateway/edit"
export const GATEWAY_DETAIL = "/gateway/detail"

//RES URL
export const RES_LIST_GET = "/res/upgrade/list/get"
export const RES_FILE_ADD = "/res/upgrade/upload"
export const RES_FILE_DEL = "/res/upgrade/list/del"
export const RES_FILE_UPDATE = "/res/upgrade/edit"

//ECONFIG URL
export const ECONFIG_GET = "/econfig/get"
export const ECONFIG_UPDATE = "/econfig/update"
export const BANK_LIST = "/comm/banks/nams/list/get"
export const SHARE_GET = "/share/config/get"
export const SHARE_UPDATE = "/share/config/update"

//REPLACE URL
export const REPLACE_LIST_GET = "/device/replace/history/list"

//TASK HISTORY URL
export const TASK_HISTORY_LIST_GET = "/getway/device/upgrade/history/list/get"

//TASK  URL
export const TASK_LIST_GET = "/getway/device/upgrade/list/get"

//GROUP URL
export const COMPANY_GROUP_LIST = "/enterprise/group/list/get"
export const COMPANY_GROUP_ADD = "/enterprise/group/add"
export const COMPANY_GROUP_DEL = "/enterprise/group/del"

export const AGENTS_GROUP_LIST = "/agents/group/list/get"
export const AGENTS_GROUP_ADD = "/agents/group/add"
export const AGENTS_GROUP_DEL = "/agents/group/del"

export const COMPANY_GUSER_LIST = "/enterprise/group/user/list"
export const COMPANY_GUSER_ADD = "/enterprise/group/user/add"
export const COMPANY_GUSER_DEL = "/enterprise/group/user/del"

export const AGENTS_GUSER_LIST = "/agents/group/user/list"
export const AGENTS_GUSER_ADD = "/agents/group/user/add"
export const AGENTS_GUSER_DEL = "/agents/group/user/del"

export const COMPANY_GRIGHT_ALL = "/enterprise/right/get"
export const COMPANY_GRIGHT_LIST = "/enterprise/group/right/get"
export const COMPANY_GRIGHT_UPDATE = "/enterprise/group/right/update"

export const AGENTS_GRIGHT_ALL = "/agents/right/list"
export const AGENTS_GRIGHT_LIST = "/agents/group/right/list"
export const AGENTS_GRIGHT_UPDATE = "/agents/group/right/update"

export const COMPANY_GAREA_ADD = "/enterprise/group/area/add"
export const COMPANY_GAREA_DEL = "/enterprise/group/area/del"
export const COMPANY_GAREA_GET = "/enterprise/group/area/get"

//menu url
export const MENU_GET = "/right/menu/get"

//GET DG ID URL
export const PLATFROM_GET_EGID = "/platform/enterprise/group/default/get"
export const COMPANY_DG_GET = "/enterprise/group/default/get"

//share
export const SHARE_PROJECT_GET = "/enterprise/project/share/get"
export const SHARE_ALL_UPDATE = "/enterprise/share/update"

//replace
export const GATEWAY_REPLACE = "/device/replace"
export const GATEWAY_ADD = "/gateway/add"
export const GATEWAY_RESET = "/gateway/project/reset"
export const GATEWAY_UPGRADE = "/getway/device/upgrade/device/upgrade"
export const COMPANY_GET_AGID = "/enterprise/agents/group/default/get"
export const AGENTS_GAREA_ADD = "/enterprise/agents/area/add"
export const AGENTS_GAREA_DEL = "/enterprise/agents/area/del"
export const AGENTS_GAREA_GET = "/enterprise/agents/area/get"
export const AGENTS_DG_GET = "/agents/group/default/get"
export const USER_CURRENT_GET = "/user/current/get"
export const PLATFORM_GET_PROJECT = "/project/list/get/enterprise"
export const PROJECT_REPORT_GET = "/project/statistic"
//order
export const BANK_TRANSFER_ALL_INFO = "/share/share/list/all/get"
// 分账报表文件导出接口
export const BANK_TRANSFER_ALL_EXPORT = "/share/share/list/all/export"
export const BANK_ORDER_ALL_EXPORT = "/share/order/list/all/export"
export const BANK_TRANSFER_HISTORY = "/enterprise/share/history/list/get"
export const BANK_TRANSFER_INFO = "/enterprise/share/list/get"
export const BANK_TRANSFER_INFO_DEL = "/enterprise/share/list/del"
export const BANK_ORDER_LIST = "/share/order/list/get"
export const BANK_RECORD_LIST = "/share/record/list/get"
export const BANK_SHARE_LIST = "/share/share/list/get"
export const BANK_ORDER_ALL_LIST = "/share/order/list/all/get"
//upgrade
export const TASK_CHILD_GET = "/getway/device/upgrade/list/child/get"
export const TASK_HCHILD_GET = "/getway/device/upgrade/history/list/child/get"
export const TASK_STOP = "/getway/device/upgrade/stop"
export const USER_UPDATE = "/user/current/update"
//feedback
export const PROBLEM_LIST = "/problem/list"
export const PROBLEM_CONFIRM = "/problem/confirm"
//dev import
export const IMPORT_GATEWAY = "/gateway/upload"

//user recharge list
export const USER_RECHARGE_LIST = "/share/recharge/list/get"
export const SHARE_CHARGE_LIST = "/share/recharge/order/list/get"
export const RECHARGE_SHARE_LIST = "/recharge/share/list/get"
export const RECHARGE_LIST = "/recharge/list/get"
// 用户充值记录文件到处接口
export const RECHARGE_LIST_EXPORT = "/recharge/list/export"

//PROJrule
export const RULE_LIST = "/orderrule/rule/list/get"
export const RULE_ADD = "/orderrule/rule/add"
export const RULE_DEL = "/orderrule/rule/del"
export const RULE_UPDATE = "/orderrule/rule/update/info"
export const RULE_ITEM_ADD = "/orderrule/rule/item/add"
export const RULE_ITEM_LIST = "/orderrule/rule/item/list/get"

//ordering
export const ORDER_ING_LIST = "/ordering/ing/list/get"
export const ORDER_ING_END = "/ordering/hand/end/order/ing"
export const ORDER_ING_INFO_GET = "/ordering/ing/project/info/get"

//project account
export const COMPANY_SHARE_GET = "/econfig/config/get"
export const COMPANY_SHARE_UPDATE = "/econfig/config/update"

//logger list
export const LOGGER_LIST = "/debugging/log/record/list"
export const LOGGER_UPDATE = "/debugging/log/record/update"
export const LOGGER_DOWNLOAD = "/debugging/log/download"
export const LOGGER_SETTING = "/debugging/log/setting"
export const LOGGER_UPLOAD = "/debugging/log/upload/set"

//power reporter
export const POWER_SETTING = "/debugging/power/report/setting"
export const POWER_UPDATE = "/debugging/power/threshold/update"
export const POWER_LIST = "/debugging/power/record/list"
export const POWER_ITEM = "/debugging/power/record/item"
export const POWER_INSPECT = "/debugging/power/monitor/setting"
export const POWER_STATUS = "/debugging/power/report/status"

//private user
export const PROJECT_PRIVATE_USER_LIST = "/projectuser/list/get"
export const PROJECT_PRIVATE_USER_ADD = "/projectuser/add"
export const PROJECT_PRIVATE_USER_DEL = "/projectuser/dels"
export const PROJECT_PRIVATE_USER_UPDATE = "/projectuser/update"
export const PROJECT_PRIVATE_USER_IMPORT = "/projectuser/import"
export const PROJECT_PRIVATE_USER_EXCEL = "/static/file/project-user-import.xls"

//device type
export const DEVICE_TYPE_LIST = "/devicetype/list"
export const DEVICE_TYPE_ADD = "/devicetype/add"
export const DEVICE_TYPE_DEL = "/devicetype/delete"
export const DEVICE_TYPE_UPDATE = "/devicetype/update"

//app version setting
export const APP_VERSION_GET = "/comm/version/get"
export const APP_VERSION_UPDATE ="/comm/version/update"

//get platform oem
export const PLATFORM_OEM_URL = "/comm/platform/name/get"

//gateway operate
export const GATEWAY_OPER_OPEN = "/debugging/operation/create"
export const GATEWAY_OPER_CLOSE = "/debugging/operation/close"
export const GATEWAY_OPER_HEARTBEAT = "/debugging/operation/heartbeat"
export const GATEWAY_OPER_DOWNLOAD = "/debugging/operation/download"
export const GATEWAY_OPER_CMD = "/debugging/operate"

//proj power manager
export const PROJECT_GET_POWER_LIST = "/projpower/list/get"
export const PROJECT_POWER_ADD = "/projpower/add"
export const PROJECT_POWER_DEL = "/projpower/del"
export const PROJECT_POWER_UPDATE = "/projpower/update"

// project once manager
export const PROJECT_GET_ONCE_GEAR_LIST = "/projectoncegear/list/get"
export const PROJECT_ONCE_GEAR_ADD = "/projectoncegear/add"
export const PROJECT_ONCE_GEAR_DEL = "/projectoncegear/del"
export const PROJECT_ONCE_GEAR_UPDATE = "/projectoncegear/update"

//alarm type
export const ALARM_TYPE_LIST = "/alarmtype/alarm/type/list/get"
export const ALARM_TYPE_ADD = "/alarmtype/alarm/type/add"
export const ALARM_TYPE_UPDATE = "/alarmtype/alarm/type/update"
export const ALARM_TYPE_DEL = "/alarmtype/alarm/type/del"

//alarm name
export const ALARM_NAME_LIST = "/alarmtype/alarm/item/type/list/get"
export const ALARM_NAME_ADD = "/alarmtype/alarm/item/type/add"
export const ALARM_NAME_UPDATE ="/alarmtype/alarm/item/type/update"
export const ALARM_NAME_DEL = "/alarmtype/alarm/item/type/del"

//alarm notify
export const ALARM_NOTIFY_LIST = "/alarmnotify/notify/list/get"
export const ALARM_NOTIFY_ADD = "/alarmnotify/notify/add"
export const ALARM_NOTIFY_UPDATE = "/alarmnotify/notify/update"
export const ALARM_NOTIFY_DEL = "/alarmnotify/notify/del"

export const ALARM_NOTIFY_USER_LIST = "/alarmnotify/notify/user/list/get"
export const ALARM_NOTIFY_USER_ADD = "/alarmnotify/notify/user/add"
export const ALARM_NOTIFY_USER_DEL = "/alarmnotify/notify/user/del"

export const PLATFORM_GET_PROJECTS = "/platform/project/list/get"
export const PLATFORM_GET_AGENTS = "/platform/agents/list/get"

//combo
export const COMBO_PROJECT_LIST = "/combo/project/combo/list/get"
export const COMBO_PROJECT_ADD = "/combo/project/combo/add"
export const COMBO_PROJECT_DEL = "/combo/project/combo/del"
export const COMBO_PROJECT_UPDATE = "/combo/project/combo/update"
export const COMBO_ORDER_LIST = "/combo/order/combo/list/get"
// 套餐消费记录文件导出接口
export const COMBO_ORDER_LIST_EXPORT = "/combo/order/combo/list/export"

export const COMBO_ORDER_PROJECT_LIST = "/combo/project/oper/combo/list/get"
export const PROJUSER_PROJECT_GET = "/project/curuser/project/get"

//appuser
export const APP_USER_LIST = "/appuser/list/get"
export const APP_USER_BACK_MONEY = "/appuser/user/recharge/back"

//ecard
export const ECARD_LIST = "/electriccard/list"

//orderinfo
export const ORDER_OTHER_INFO = "/share/order/otherinfo/list/get"
export const ORDER_OTHER_INFO_DETAIL = "/share/order/otherinfo/parent/info"
export const ORDER_OTHER_INFO_POWER = "/share/order/otherinfo/power/info"
export const ORDER_OTHER_INFO_EXPORT = "/share/order/otherinfo/power/export"

//imuser url
export const IMUSER_LIST_GET = "/im/iminfo/user/list/get"
export const IMUSER_ADD = "/im/iminfo/user/add"
export const IMUSER_DEL = "/im/iminfo/user/del"
export const IMUSER_UPDATE = ""

//imreport url
export const IMINFO_LIST_GET = "/im/iminfo/list/get"
export const IMINFO_CLOSE = "/im/iminfo/close"
export const IMINFO_PING = "/im/iminfo/level/ping/get"
export const IMINFO_PING_GATEWAY = "/im/iminfo/level/ping/platform/gateway/get"

export const IMINFO_GATEWAY_GET = "/im/iminfo/level/gateway/get"
export const IMINFO_TERMINAL_GET = "/im/iminfo/level/gateway/terminal/get"
export const IMINFO_NFC_GET = "/im/iminfo/level/nfc/get"

export const IMINFO_MALF_LIST = "/im/iminfo/level/malfunction/get"
export const IMINFO_MALF_HISTORY_LIST = "/im/iminfo/level/malfunction/history/get"

export const IMINFO_GW_UPGRADE_GET = "/im/iminfo/level/gateway/upgrade/get "
export const IMINFO_TM_UPGRADE_GET = "/im/iminfo/level/terminal/upgrade/get"
export const IMINFO_TM_ITEM_UPGRADE_GET = "/im/iminfo/level/terminal/upgrade/item/get"

export const IMINFO_TERM_NUM_GET = "/im/iminfo/level/number/get"
export const IMINFO_CHECK_TERM_GET = "/im/iminfo/level/checkup/terminalsn/get"


//right url
export const RIGHT_LIST = "/right/right/list"
export const RIGHT_TARGET_ADD = "/right/role/target/add"
export const RIGHT_TARGET_DEL = "/right/role/target/del"

//profit url
export const PROFIT_LIST_URL = "/project/income"

// upg task url
export const UPG_TASK_LIST = "/getway/device/upgrade/task/list"
export const UPG_TASK_ITEM_LIST = "/getway/device/upgrade/task/item/list"
export const UPG_TASK_CREATE = "/getway/device/upgrade/task"
export const ALARM_COUNT_GET = "/alarm/count/statistics"

// discount url
export const PROJ_DISCOUNT_LIST = "/project/recharge/discount/list/get"
export const PROJ_DISCOUNT_ADD = "/project/recharge/discount/add"
export const PROJ_DISCOUNT_UPDATE = "/project/recharge/discount/update"
export const PROJ_DISCOUNT_DEL = "/project/recharge/discount/del"

// card limit url
export const CARD_LIMIT_LIST = "/cardconsumerlimit/list/get"
export const CARD_LIMIT_ADD = "/cardconsumerlimit/add"
export const CARD_LIMIT_UPDATE = "/cardconsumerlimit/update"
export const CARD_LIMIT_DEL = "/cardconsumerlimit/delete"

// share export url
export const SHARE_EXPORT_URL = "/share/record/list/export"
export const SHARE_DETAIL_URL = "/share/record/list/child/export"

// vuser url
export const VUSER_LIST = "/virtualuser/list/get"
export const VUSER_ADD = "/virtualuser/add"
export const VUSER_UPDATE = "/virtualuser/update"
export const VUSER_DEL = "/virtualuser/del"
export const VUSER_REFUND = "/virtualuser/refund"
export const VUSER_RECHARGE = "/virtualuser/recharge"
export const VUSER_REFUND_REPORT = "/virtual/refund/list/get"
export const VUSER_CHARGE_REPORT = "/virtual/recharge/list/get"

// im url
export const IMINFO_OPEN = "/im/iminfo/open"
export const IMINFO_UPLOAD = "/im/malfunction/upload"
export const IMINFO_END = "/im/iminfo/compelete"
export const IMINFO_SOCKET_LIST = "/im/get/socket"
export const IMINFO_TEST_PING = "/im/iminfo/ping/gateway/test"
export const IMINFO_TEST_GATEWAY = "/im/iminfo/gateway/test"
export const IMINFO_TEST_TERM = "/im/iminfo/terminal/test"

// new agent url
export const AGENTID_RIGHT_LIST = "/agents/agents/group/right/list"
export const AGENTID_RIGHT_UPDATE ="/agents/agents/group/right/update"
export const AGENT_NOPAGE_LIST = "/agents/agents/nopage/list/get"

// right url
export const RIGHT_LIST_GET = "/right/user/list/get"

// usercenter url
export const CUSER_LIST = "/appusermanager/user/list/get"
export const COMPENSATION_LIST = "/appusermanager/user/compensation/list/get"
export const REFUND_LIST = "/appusermanager/user/recharge/refund/list/get"
export const COMPENSATE_OPER = "/appusermanager/user/compensation"
export const REFUND_CANCEL = "/appusermanager/user/recharge/refund/cancel"
export const APP_USER_CHARGE_LIST = "/appusermanager/user/recharge/list/get"
export const REFUND_OPER = "/appusermanager/user/recharge/refund"
export const REFUND_RESET = "/appusermanager/user/balace/reset"
export const CONSUMERPROJECT_UPDATE = "/appusermanager/user/consumerproject/update"


// WEBPACK FOOTER //
// ./src/fetch/url.js